import type { FaireProductEntity } from "../../entity_types/product";

export const p_pkrunt99xa: FaireProductEntity = {
  token: "p_pkrunt99xa",
  type: "product",
  name: "Purely Matcha On the Go - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/6ee42b5852e7d3b75a300d32aaa0b63471dfb949ce1ef40c6e144246de93617b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4f1b1c9be4bc09fe5f58e803808d78e80a8cd4158100e9bbf5fded706192afd.jpeg",
    "https://cdn.faire.com/fastly/1f8427fd2b80af60d04819f5fdadebe22047d7354c8e6116d0c141634ed1243f.jpeg",
    "https://cdn.faire.com/fastly/6516ede6350b7c264e60f27533b50c3cca7af62f7ac63c6ddcfafabb6d27d74f.jpeg"
  ],
  priceDollars: 15.75,
  description: "Your Daily Glow, To-Go!\n\nFinally, a matcha sachet that actually hits. We know your mornings are a marathon, so we created a portable ritual that doesn't make you compromise on strength or quality. No more weak lattes or needing two packets to get the green you love. \n\nWhether you’re crushing a workout, back-to-back in meetings, or just trying to survive a long flight, your \"main character\" energy is officially portable.\n\n100% ORGANIC CEREMONIAL GRADE MATCHA - RAW - SPRING HARVEST \n\n15 x 2g Sachets Per Canister\n\nHow to Enjoy:\n\n * Whisk the contents of 1 packet of matcha powder with 1 tbsp hot (not boiling) water until tiny bubbles form. Top with 1 cup of hot or cold milk for a matcha latte. Sweeten to taste if desired.\n\n * Add to smoothies and baked goods! \n\nWhen to Enjoy:\n\n * As a substitute for your morning coffee \n * As a smooth, mid-day pick-me-up \n * When you need to boost your mood \n\nModerate caffeine levels\n",
  tags: [],
  msrpDollars: 24.15,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:44.358Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
